import React from 'react';
import _ from 'lodash';
import { appContext } from '../util/decorators';

@appContext
export default class VideoPlayerMessageWrapper extends React.PureComponent {
  static propTypes = {
    video: React.PropTypes.object.isRequired,
    article: React.PropTypes.object.isRequired,
    children: React.PropTypes.node,
  };

  render() {
    const { app } = this.context;
    const { video, article } = this.props;

    // TODO: "48h clip" will become "48h-clip" in [VIP-28624], so once deployed
    // the check below can be simplified
    const isExpiredVideo = (_.includes(article.tags.videoTypes, '48h clip')
      || _.includes(article.tags.videoTypes, '48h-clip'))
      && app.serverTime().isAfter(video.endPlaybackAt);

    if (!isExpiredVideo) return this.props.children;

    return (
      <div className="video-player-message">
        {app.t('VideoPlayer.video_expired')}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/VideoPlayerMessageWrapper.jsx